import ClientPaymentRefundItem from '../Domain/ClientPaymentRefundItem';
import AuthService from './authService';

export default class ClientPaymentRefundService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem
    };

    const url = `/api/ClientPaymentRefund/GetPaymentRefundAsync/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ClientPaymentRefundItem(item));
    }

    return mappedItems;
  }

  static GetById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/ClientPaymentRefund/GetById/${id ? id : 0}`);
  }
}
